/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListUsersQueryResponse,
  ListUsersQueryParams,
} from '../types/ListUsers'

function getListUsersUrl() {
  const res = { method: 'GET', url: `/api/v1/users/` as const }
  return res
}

/**
 * @description List company users with optional filters.
 * Query params:
 * user_type: Filter by group name (multi-value, e.g. ?user_type=Standard&user_type=Admin)
 * is_active: Filter by active/inactive (e.g. ?is_active=true or ?is_active=false)
 * search: Case-insensitive substring match against first_name, last_name, or email.
 * @summary List company users
 * {@link /api/v1/users/}
 */
export async function listUsers(
  params?: ListUsersQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListUsersQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListUsersUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
